import { AnimatePresence } from 'framer-motion';
import moment from 'moment';
import { Fragment, PureComponent } from 'react';
import createConsentToGetNDHMVaultDocs from '../api/createConsentToGetNDHMVaultDocs';
import fetchPatientDirByDocOid from '../api/fetchPatientDirByDocOid';
import AppLoader from '../components/common/AppLoader';
import RightPopUp from '../components/common/RightPopUp';
import { getDoc, getDocIds, getItemFromMisc, getSelectedClinicId } from '../store/idbHandler';
import MedicalRecord from './MedicalRecord';
import { DocumentsEntity } from '../api/fetchMedicalRecords';
import { captureError } from './captureError';
import { notification } from 'antd';
import { GenieSettings } from '../api/pushGenie';
import { getMActiveId } from '../store/localstorage';
import { PtDir } from '../api/fetchMyGenie';

type State = {
    mrDocs: DocumentsEntity[] | undefined;
    loading: boolean;
};

type Props = {
    consentId: string;
    plId: string;
    clearConsentId: () => void;
};

class MedicalRecordsRightPopUp extends PureComponent<Props, State> {
    state: State = {
        mrDocs: undefined,
        loading: true,
    };

    todayDate = moment(new Date()).format("DD MMM'YY");

    componentDidMount = async (): Promise<void> => {
        const { consentId, plId } = this.props;
        this.setState({ loading: true });
        const doc = getDoc();

        const settings = await getItemFromMisc<PtDir>(getMActiveId() || '', 'ptDir');

        const patientDirectory = await fetchPatientDirByDocOid(
            !settings.userLevel ? ['all'] : getDocIds(),
            plId,
        );
        const clinicId = getSelectedClinicId();

        const data = {
            patient: {
                oid: patientDirectory?.data?.[0]?.id || '',
                health_id: patientDirectory?.data?.[0]?.abha?.id || '',
            },
            hiu: {
                clinic_id: clinicId || '',
                d_oid: doc?.loginmeta?.docid || '',
            },
            consent_id: consentId,
        };

        try {
            const docs = await createConsentToGetNDHMVaultDocs(data);
            this.setState({ mrDocs: docs.documents, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            console.log(error);
            notification.error({
                message: 'Unable to fetch Docs. Something went wrong!',
                duration: 5,
                placement: 'topRight',
            });
            captureError(error as Error);
        }
    };

    render(): JSX.Element {
        const { mrDocs, loading } = this.state;
        const { plId, clearConsentId } = this.props;

        return (
            <Fragment>
                <AnimatePresence>
                    <RightPopUp closeMe={clearConsentId}>
                        <Fragment>
                            <div
                                className="flex items-center px-16 py-12 border-b border-darwin-neutral-100 bg-darwin-neutral-50"
                                style={{ height: 60 }}
                            >
                                <div
                                    className="flex items-center space-x-16"
                                    onClick={clearConsentId}
                                >
                                    <div className="flex items-center justify-center w-16 h-16 cursor-pointer">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                            className="fill-darwin-neutral-1000 w-16 h-16"
                                        >
                                            <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                        </svg>
                                    </div>
                                    <div className="rounded-t-4 text-neutral-black font-700 "></div>
                                </div>
                                <div className="font-700 text-16">{this.todayDate}</div>
                            </div>
                            {loading ? (
                                <div className="flex items-center justify-center h-full w-full">
                                    <AppLoader />
                                </div>
                            ) : (
                                <div className="px-24 py-16 space-y-24 overflow-auto">
                                    <div>
                                        <div className="grid grid-cols-3 gap-16">
                                            {mrDocs?.map((item) => (
                                                <MedicalRecord
                                                    documentFolder={{ ...item, _pt_oid: plId }}
                                                    containerCss="bg-darwin-neutral-50"
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    </RightPopUp>
                </AnimatePresence>
            </Fragment>
        );
    }
}

export default MedicalRecordsRightPopUp;
